<template>
  <div
    v-if="pageLoadingComplete"
    class="container-wrapper"
    :class="goodsData && goodsData.detail_show_type == 2 ? 'paddingShow' : ''"
  >
    <template v-if="goodsData && goodsData.detail_show_type == 2">
      <!--商品信息-->
      <div class="goods-infor">
        <div class="goods-card container">
          <div class="goods-card-title">
            <div
              class="label-box"
              v-if="goodsData.name_prefix && goodsData.name_prefix.type == 2"
              :style="bgLabel"
            >
              <img :src="goodsData.name_prefix.img" />
              {{ goodsData.name_prefix.text }}
            </div>
            {{ goodsData.name }}
          </div>
          <div class="goods-card-label" v-if="goodsData.tags.length">
            <div
              class="label-item"
              v-for="(item, index) in goodsData.tags"
              :key="index"
              :style="{ color: item.font_color, backgroundColor: item.color }"
            >
              {{ item.tag }}
            </div>
          </div>
        </div>
      </div>

      <!--商品目录-->
      <div class="goods-content">
        <van-tabs
          v-model="tabsActiveIndex"
          class="jbc-tabs"
          v-if="tabsList.length > 1"
          scrollspy
          sticky
        >
          <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
            <!-- 商品目录 -->
            <div class="goods-catalog">
              <div class="bg-white">
                <!-- 介绍页 -->
                <div v-if="item.listKey === 'intro'" class="container-row">
                  <div v-html="goodsData.intro" class="imgBox"></div>
                </div>
                <!-- 授课老师 -->
                <div v-if="item.listKey === 'teacher_list'" class="teacher">
                  <div class="teacher-title">授课老师</div>
                  <TeacherList :list="teacherList"></TeacherList>
                </div>
              </div>
              <!--目录列表-->
              <div v-if="item.listKey === 'group'" class="catalog-course">
                <div class="catalog-course-title">选择课程</div>
                <div class="catalog-list">
                  <div
                    class="catalog-list-item"
                    :class="goodsData.detail_show_type == 2 ? 'catalog-margin' : ''"
                    v-for="(item, index) in courseAllList"
                    :key="index"
                  >
                    <div class="catalog-classify" v-if="item.name">
                      {{ item.name }}
                    </div>
                    <div v-for="(ite, index1) in item.list" :key="index1" class="check-item">
                      <van-checkbox-group v-model="radio" direction="horizontal">
                        <van-checkbox
                          :name="ite.no"
                          :disabled="isDisable(ite)"
                          @click="changeCheckbox(ite)"
                          class="list-item series-card"
                        >
                          <template #icon="props">
                            <img
                              class="img-icon"
                              :class="{ disabled: isDisable(item) }"
                              :src="getCurrentBrand.imageGoodsCourseSelect"
                              v-if="props.checked"
                            />
                          </template>
                          <div class="course-item">
                            <div class="title">{{ ite.name }}</div>
                            <!-- 已购买 -->
                            <div class="content" v-if="isDisable(ite)">
                              <div class="content-left">
                                <p>已购买</p>
                              </div>
                              <div class="content-right" @click.stop="goStudy(ite)">开始学习</div>
                            </div>
                            <!-- 未购买 -->
                            <div class="content" v-else>
                              <div class="content-left">
                                <div class="money">
                                  <span>￥</span>
                                  {{ specsPrice(ite) }}
                                </div>
                                <div
                                  class="specs"
                                  v-if="ite.product.case.length > 1"
                                  @click.stop="specsClick(ite)"
                                >
                                  <span>{{ specsName(ite) }}</span>
                                  <img src="@/assets/images/collection/icon-down.png" />
                                </div>
                              </div>
                              <div
                                class="content-right"
                                @click.stop="getActionCourseDetail(ite.no)"
                              >
                                详情
                                <van-icon name="arrow" />
                              </div>
                            </div>
                          </div>
                        </van-checkbox>
                      </van-checkbox-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div v-else class="catalog-course">
          <div class="catalog-course-title">选择课程</div>
          <div class="catalog-list">
            <div class="catalog-list-item" v-for="(item, index) in courseAllList" :key="index">
              <div class="catalog-classify" v-if="item.name">
                {{ item.name }}
              </div>
              <div v-for="(ite, index1) in item.list" :key="index1">
                <van-checkbox-group v-model="radio" direction="horizontal">
                  <van-checkbox
                    :name="ite.no"
                    :disabled="isDisable(ite)"
                    @click="changeCheckbox(ite)"
                    class="list-item series-card"
                  >
                    <template #icon="props">
                      <img
                        class="img-icon"
                        :class="{ disabled: isDisable(item) }"
                        :src="getCurrentBrand.imageGoodsCourseSelect"
                        v-if="props.checked"
                      />
                    </template>
                    <div class="course-item">
                      <div class="title">{{ ite.name }}</div>
                      <!-- 已购买 -->
                      <div class="content" v-if="isDisable(ite)">
                        <div class="content-left">
                          <p>已购买</p>
                        </div>
                        <div class="content-right" @click.stop="goStudy(ite)">开始学习</div>
                      </div>
                      <!-- 未购买 -->
                      <div class="content" v-else>
                        <div class="content-left">
                          <div class="money">
                            <span>￥</span>
                            {{ specsPrice(ite) }}
                          </div>
                          <div
                            class="specs"
                            v-if="ite.product.case.length > 1"
                            @click.stop="specsClick(ite)"
                          >
                            <span>{{ specsName(ite) }}</span>
                            <img src="@/assets/images/collection/icon-down.png" />
                          </div>
                        </div>
                        <div class="content-right" @click.stop="getActionCourseDetail(ite.no)">
                          详情
                          <van-icon name="arrow" />
                        </div>
                      </div>
                    </div>
                  </van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="green-box" v-if="goodsData">
        <div class="green-h">
          <div class="title">{{ goodsData.name }}</div>
          <span v-if="goodsData.list && goodsData.list.length">
            共{{ goodsData.list.length }}套课程
          </span>
        </div>
        <div class="green-content">
          <div
            class="course-item-t"
            v-for="(item, index) in goodsData.list"
            :key="index"
            @click="goStudy(item)"
          >
            <div class="course-card-title van-multi-ellipsis--l2">
              <div class="label-box" v-if="item.name_prefix" :style="bgLabelList(item)">
                <img :src="item.name_prefix.img" />
                {{ item.name_prefix.text }}
              </div>
              {{ item.name }}
            </div>
            <div class="course-summary">{{ item.summary }}</div>
            <div class="course-item-bt">
              <div class="teacher-list" v-if="allBuyCourseTeacherList">
                <div class="teacher-item" v-for="(ite, index1) in item.teacher" :key="index1">
                  <img
                    :src="allBuyCourseTeacherList[ite] && allBuyCourseTeacherList[ite].portrait"
                  />
                  {{ allBuyCourseTeacherList[ite] && allBuyCourseTeacherList[ite].name }}
                </div>
                <!-- {{ allBuyCourseTeacherList[ite] }} -->
              </div>
              <div class="right-con">
                <div class="money" v-if="item.usability !== 'free'">
                  <span>￥</span>
                  {{ priceVip(item) }}
                </div>
                <div class="free" v-else>免费</div>
                <div class="people">{{ item.participants }}人已学</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <van-empty v-if="courseDefault" description="没有找到对应课程" />

    <!--课程弹窗-->
    <van-action-sheet
      id="course-action-sheet"
      :title="currentActionCourse.name"
      v-model="showActionCourse"
      @open="showCourse = true"
      @closed="showCourse = false"
    >
      <action-course
        v-if="showCourse"
        unitName="course"
        :goods-data="currentActionCourse"
        :course-no="actionCourseNo"
      />
    </van-action-sheet>

    <!--购买按钮-->
    <FooterButtonBuy
      v-if="!is_buy && goodsData && goodsData.detail_show_type == 2"
      buttonText="立即购买"
      :radio="radio.length"
      :allPrice="buyPriceText"
      :isDisable="isDisableButton"
      :customerInfoURL="goodsCustomerUrl"
      @clickButton="clickBuy"
    />
    <!-- 侧边打开APP悬浮按钮(停售且未购买时不显示) -->
    <SideOpenApp
      v-if="goodsData"
      unitKey="CourseCollection"
      :options="{ collection_no: goodsData && goodsData.no }"
    />

    <!-- 打开app,用于app内打开 -->
    <FooterOpenApp
      ref="footer_open_app"
      :name="getCurrentBrand.name"
      :logoImage="getCurrentBrand.imageLogoURL"
      :text="currentUnit.openAppText"
      :schemaUnitKey="currentUnit.schemaUnitKey"
      style="display: none"
    />

    <!--商品规格选择-->
    <van-action-sheet
      v-model="isSpecsAction"
      title="规格选择"
      :closeable="false"
      class="specs-action container"
    >
      <SpecsAction
        :list="productCases.cases"
        :no="productCases.no"
        @confirmClick="specsTriggerAction"
        @change="changeSpecsItem"
        :isVipPricePower="true"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import TeacherList from '@/components/Course/TeacherList.vue'
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import FooterButtonBuy from '@/components/FooterButtonCourse.vue'
import SideOpenApp from '@/components/SideOpenApp.vue'
import SpecsAction from '@/components/Course/SpecsAction'
import ActionCourse from '@/views/goods/components/ActionCourse'
import { getCourseCollectionDetailApi, getCourseDetail } from '@/api/goods/detail'

import { getCollectionDetailApi } from '@/api/collection/detail'

const apiTeacherDetail = require('@/api/teacher').teacherDetail
import goodsCommon from '@/views/collection/mixins/collectionCommon'

export default {
  components: {
    TeacherList,
    FooterOpenApp,
    FooterButtonBuy,
    SideOpenApp,
    SpecsAction,
    ActionCourse,
  },
  data() {
    return {
      pageLoadingComplete: false,
      unitName: '',
      unitNameList: {
        course_collection: {
          request: getCourseCollectionDetailApi,
          schemaUnitKey: 'CourseCollection',
          goodsAddRequestType: 'CourseCollection',
          openAppText: '开始学习',
          title: '：精品合辑课程分享',
        },
      },

      goodsData: null, // 商品数据

      goodsGroup: [], //系列分组
      courseList: [], //该系列下所有课程
      actionAllCourseList: {}, //所有弹窗课程列表
      actionCourseNo: '', //当前弹窗课程编号
      currentActionCourse: {}, //当前弹窗课程数据

      totalPrice: 0, //价格合计

      courseReserveBuyNoList: {}, //用户待购买的课程编号列表

      // 是否禁用按钮
      isDisableButton: false,

      // 是否购买
      is_buy: false,
      showActionCourse: false,

      allBuyCourseTeacherList: null,
      showCourse: false,
      // tab列表数据
      tabsList: [],
      tabsActiveIndex: 0, //tab选中下标
      teacherList: [],
      result: [],
      isSpecsAction: false, //是否显示勾选规格按钮
      // 商品规格
      productCases: {
        no: '',
        cases: [],
      },
      bgLabel: {
        color: '',
        backgroundColor: '',
      },
      courseAllList: [],
      radio: [],
      whetherList: [], //判断是否选中过规格
      courseDefault: false,
    }
  },
  mixins: [goodsCommon],
  computed: {
    // 当前单元
    currentUnit() {
      return this.unitNameList['course_collection']
    },
    buyPriceText() {
      return this.totalPrice > 0 ? `${this.totalPrice}` : ''
    },
    isShowGoodsQQ() {
      return this.goodsData?.qq && this.goodsData.qq.length > 0
    },
    // 已经购买的课程列表
    buyCourseList() {
      return this.goodsData.course_list.filter((item) => {
        return item.is_buy === true
      })
    },
    // 是否购买所有课程
    isBuyAllCourse() {
      let result = true
      this.courseList.forEach((item) => {
        !item.is_buy && (result = false)
      })
      return result
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return function (obj) {
        return obj.is_membership_price
      }
    },
    // 是否有会员价格
    isHasVipPrice() {
      return function (obj) {
        const price = obj.membership_price
        return !!price && price !== '0.00'
      }
    },
    // 查询指定购买课程老师信息
    queryBuyCourseTeachers() {
      return function (ids) {
        let result = []
        ids?.forEach((id) => {
          result.push(this.allBuyCourseTeacherList[id])
        })
        return result
      }
    },
    //查询课程
    queryCourse() {
      return function (no) {
        let result = {}
        this.courseList.forEach((item) => {
          item.no === no && (result = item)
        })
        return result
      }
    },
    isDisable() {
      return function (item) {
        return item.is_buy
      }
    },
    //计算价格
    priceVip() {
      return function (item) {
        return item.product
          ? this.clearPriceZero(
              this.goodsData.is_membership_price
                ? item.product.membership_price > 0
                  ? item.product.membership_price
                  : '免费'
                : item.product.price > 0
                ? item.product.price
                : '免费'
            )
          : '免费'
      }
    },
    // 商品客服链接
    goodsCustomerUrl() {
      // 先取出客服列表 & 客户信息（避免重复?.）
      const serviceList = this.goodsData?.customer_service || []
      const customerInfo = this.goodsData?.customer_info

      // 优先取客服第一条，没有则取客户信息里的url
      return serviceList.length > 0 ? serviceList[0].value : customerInfo?.url
    },
  },
  created() {
    this.unitName = this.$route.params.unitName
    document.title = this.getCurrentBrand.name + this.currentUnit.title
    this.getGoodsDetail()
    this.isAPP()
  },
  methods: {
    // 获取商品详情
    getGoodsDetail() {
      let params = {
        no: this.$route.query.collection_no,
        brand: this.$route.query.brand,
        province: this.$route.query.province,
      }
      // params.no = this.$route.query.no
      // 商品请求
      getCollectionDetailApi({ ...params }).then((res) => {
        // 页面加载完成
        this.pageLoadingComplete = true
        if (res.status == 1 || res.status == 6001) {
          let resData = res.data
          // 当页面状态是未购买的时  刷新购买状态
          if (!this.is_buy) {
            this.updateGoodsBuySate(resData.is_buy)
          }
          // 初始化商品规格数据
          this.updateGoodsProduct(resData?.product)
          // 格式化商品数据
          this.dataGoodsFormatMiddle(resData)
          // 获取老师列表
          this.getTeacherDetail(resData.teacher)
          this.goodsGroup = resData.group
          this.courseList = resData.list
          this.getAllBuyCourseTeacherList()
          this.updateSeriesCourseBuy()
          this.$util.setShare({
            title: resData.share.title,
            desc: resData.share.desc,
            link: window.location.href,
            imgUrl: resData.share.image || '',
          })
          try {
            const list = resData?.list || []
            this.setupRecommendCode(this.$route.query, {
              rcode_range: 'course',
              rcode_value: list.map((item) => item.no).join(','),
            })
          } catch (error) {}
          // 跳转登录
        } else {
          this.courseDefault = true
        }
      })
    },
    // 触发规格勾选
    specsTriggerAction(no) {
      this.isSpecsAction = !this.isSpecsAction
      this.courseAllList.forEach((item) => {
        item.list.some((ite) => {
          if (ite.no == no) {
            ite.product.case = this.productCases.cases
            return true
          }
        })
      })
      this.goodsData.list.forEach((item) => {
        item.product.case.some((ite) => {
          if (ite.default == 1) {
            item.product.price = ite.amount
            item.product.membership_price = ite.amount_membership
            return true
          }
        })
      })
      this.updateTotalPrice()
    },
    // 更改规格
    changeSpecsItem(list) {
      this.productCases.cases = list
    },
    // 更新系列课程购买状态
    updateSeriesCourseBuy() {
      if (this.$route.query.isChooseCourse) {
        this.updateGoodsBuySate(false)
        return false
      }

      this.updateGoodsBuySate(this.goodsData.is_buy)
    },

    clickButton(o) {
      const no = o.no
      this.getActionCourseDetail(no)
    },
    // 获取所有的老师列表
    getAllBuyCourseTeacherList() {
      let teacherList = []
      this.goodsData.list.forEach((item) => {
        item?.teacher?.forEach((teacherId) => {
          teacherList.indexOf(teacherId) === -1 && teacherList.push(teacherId)
        })
      })
      apiTeacherDetail(this.routeFixedParam({ id: teacherList.join(',') })).then((res) => {
        let list = res.data
        let allBuyCourseTeacherList = {}
        list.forEach((item) => {
          allBuyCourseTeacherList[item.id] = item
        })
        this.allBuyCourseTeacherList = allBuyCourseTeacherList
      })
    },
    // 复选框change时触发
    changeCheckbox(o) {
      //判断是否弹出规格弹窗
      if (!this.whetherList.some((ite) => ite === o.no) && o.product.case.length > 1) {
        this.specsClick(o)
      }
      const no = o.no
      this.courseReserveBuyNoList[no] = !this.courseReserveBuyNoList[no]
      this.updateTotalPrice()
    },
    // 更新合计价格
    updateTotalPrice() {
      let totalPrice = 0
      this.goodsData.list.map((item) => {
        let no = item.no
        if (this.courseReserveBuyNoList[no]) {
          // 有会员价且有会员价购买资格
          if (this.isHasVipPrice(item.product) && this.isVipPricePower(item)) {
            totalPrice += Number(item.product.membership_price)
          } else {
            totalPrice += Number(item.product.price)
          }
        }
      })
      this.totalPrice = this.formatFloat(totalPrice, 2)
    },
    // 保留两位小数 浮点数四舍五入 位数不够 不补0
    formatFloat(src, pos) {
      return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos)
    },
    // 获取当前弹窗课程数据
    getActionCourseDetail(no) {
      const params = this.routeFixedParam()
      params.no = no
      return getCourseDetail(params).then((res) => {
        this.actionCourseNo = no
        this.actionAllCourseList[no] = res.data
        this.currentActionCourse = res.data
        console.log(this.currentActionCourse, '规格')
        this.showActionCourse = true
      })
    },
    toChooseCourse() {
      let query = this.$route.query
      query.isChooseCourse = true
      this.$util.windowLocationHref(window.location.pathname + '?' + this.$util.getURLParam(query))
    },
    sheetClosed() {
      document.querySelector('#course-action-sheet .van-action-sheet__content').scrollTop = 0
      // let f = document.getElementById('#course-action-sheet')
      // console.log(document.getElementById('#course-action-sheet').scrollTop=0)
      console.log(
        document.querySelector('#course-action-sheet .van-action-sheet__content').scrollIntoView()
      )
    },
    //判断是否是app
    isAPP() {
      if (window?.webkit?.messageHandlers?.canLoadShare || window?.tikuWeb?.setShareHtml) {
        window.history.back()
        this.openApp()
        return true
      }
      console.log('开始打印 ')
      console.log(window?.webkit?.messageHandlers?.canLoadShare, window?.tikuWeb?.setShareHtml)
      return false
    },
    // 打开app
    openApp() {
      this.pageLoadingComplete = true
      setTimeout(() => {
        this.$refs.footer_open_app.openApp()
      })
    },
    // 点击购买
    clickBuy() {
      // 如果是app则不再往下执行
      if (this.isAPP()) {
        return false
      }
      if (this.checkUserNotLogin()) {
        return false
      }

      let courseReserveBuyNoList = this.courseReserveBuyNoList
      let productList = []

      for (let no in courseReserveBuyNoList) {
        if (courseReserveBuyNoList[no]) {
          let course = this.queryCourse(no)
          let selectedCase = course.product.case.find((ite) => ite.default === 1)
          productList.push({
            product_no: course.product.no,
            case_id: selectedCase.id,
            count: 1,
          })
        }
      }
      if (productList.length === 0) {
        this.$toast('请选择课程')
        return
      }
      this.goPay(productList)
    },
    // 获取默认规格
    specsName(item) {
      const selectedCase = item.product.case.find((ite) => ite.default === 1)
      return selectedCase ? selectedCase.name : ''
    },
    //获取默认价格
    specsPrice(item) {
      const selectedCase = item.product.case.find((ite) => ite.default === 1)
      return this.clearPriceZero(
        selectedCase && this.goodsData.is_membership_price
          ? selectedCase.amount_membership > 0
            ? selectedCase.amount_membership
            : '免费'
          : selectedCase.amount > 0
          ? selectedCase.amount
          : '免费'
      )
    },
    //打开规格
    specsClick(ite) {
      this.productCases.cases = ite.product.case
      this.productCases.no = ite.no
      this.isSpecsAction = true
      this.whetherList.push(ite.no)
    },
    goStudy(ite) {
      let param = {
        brand: this.$route.query.brand,
        province: this.$route.query.province,
        no: ite.no,
      }
      this.$router.push({
        path: '/course/detail',
        query: param,
      })
    },
    bgLabelList(item) {
      return {
        color: item.name_prefix.font_color,
        backgroundColor: item.name_prefix.bg_color,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.goods {
  &-catalog {
    .header {
      padding-top: 0.5rem;
      margin-bottom: 0.2rem;

      .title {
        font-size: $font36;
        font-weight: bold;
      }

      .subtitle {
        font-size: $font28;
        color: #919499;
        margin-left: 0.2rem;
      }
    }

    .image {
      display: block;
      width: 100%;
    }
  }
}

/deep/ {
  .jbc-tabs {
    .van-tabs__wrap {
      height: 1.6rem;

      .van-tabs__nav {
        padding-bottom: 0;
        box-sizing: border-box;
      }
    }

    .van-tabs__line {
      bottom: 0.2rem;
    }
  }

  .imgBox img {
    max-width: 100%;
  }

  .hideTabNav {
    .van-tabs__wrap {
      display: none !important;
    }
  }
}

.van-tab__pane {
  &:nth-last-child(1) {
    min-height: 90vh;

    .goods-catalog {
      border: none;
    }
  }
}

.container-buy {
  .goods-catalog {
    border: none;
  }
}

.container-wrapper {
  min-height: 100vh;
  box-sizing: border-box;

  &.container-buy {
    .van-tab__pane {
      &:nth-last-child(1) {
        min-height: auto;
      }
    }
  }
}

.van-action-sheet {
  max-height: 90%;
}

.goods {
  &-card {
    padding-top: 0.2rem;
    padding-bottom: 0.3rem;
    background: #fff;

    &-title {
      font-size: 0.48rem;
      line-height: 0.8rem;
      color: $color_black;
      font-weight: bold;
      margin-bottom: 0.3rem;

      .label-box {
        border-radius: 20px;
        font-size: 0.38rem;
        position: relative;
        display: inline-block;
        padding: 0.1rem 0.27rem 0.1rem 0.6rem;
        font-weight: normal;
        line-height: 1;

        img {
          width: 0.53rem;
          height: 0.53rem;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        span {
          font-size: 0.48rem;
        }
      }
    }
  }

  &-specs {
    &-list {
      .van-cell::after {
        background: red;
        display: none;
      }
    }

    &-item {
      display: flex;
      padding: 0.2rem 0;

      .name {
        width: 1.28rem;
        font-size: 0.4rem;
        color: #919499;
        line-height: 0.4rem;
      }

      .content {
        position: relative;
        display: flex;
        align-items: flex-end;
        flex: 1;
        font-size: 0;

        span {
          font-size: 0.4rem;
          line-height: 0.4rem;
        }

        .icon {
          position: absolute;
          width: 0.5rem;
          top: 0;
          right: 0;
        }
      }

      .price {
        &-text {
          .symbol {
            font-size: 0.35rem;
          }

          .number {
            font-size: 0.42rem;
            font-weight: bold;
          }

          &_new {
            color: #ff6a4d;
          }

          &_old {
            color: #919499;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}

.question-count {
  display: flex;

  &-item {
    font-size: 0.37rem;
    line-height: 0.35rem;
    color: #919499;
    padding-right: 0.7rem;

    .icon {
      display: inline-block;
      transform: translateY(0.05rem);
      margin-right: 0.2rem;
    }
  }
}

.goods-content {
  border-top: 0.21rem solid #f7f8fa;
}

::v-deep .van-action-sheet__header {
  font-size: 0.48rem;
  line-height: 0.8rem;
  color: $color_black;
  font-weight: bold;
  text-align: left;
  padding-left: 0.53rem;
  padding-right: 0.53rem;
  padding-top: 0.64rem;
}

.van-action-sheet__close {
  font-size: 0.38rem;
  line-height: 1;
  padding-top: 0.29rem;
  padding-right: 0.29rem;
  color: #92959a;
  font-weight: bold;
  cursor: pointer;
}

.catalog-course-collection-buy-item {
  border-bottom: 1px solid #ebecf0;

  &:nth-last-child(1) {
    border: none;
  }
}

/deep/ {
  .van-sticky.van-sticky--fixed {
    @include maxWidth();
  }

  #course-action-sheet .van-sticky.van-sticky--fixed {
    max-width: 100% !important;
  }
}

.goods-card-label {
  display: flex;
  flex-wrap: wrap;

  .label-item {
    font-size: 0.24rem;
    padding: 0.05rem 0.16rem;
    border-radius: 0.11rem;
    margin-right: 0.21rem;
    margin-bottom: 0.21rem;
  }
}

.teacher {
  &-title {
    font-size: 0.4rem;
    color: #22242e;
    padding-top: 0.53rem;
    // margin-bottom: 0.2rem;
    font-weight: bold;
  }
}

.catalog-course {
  padding-left: 0.53rem;
  padding-right: 0.53rem;

  &-title {
    font-size: 0.48rem;
    color: #22242e;
    font-weight: 600;
    padding-top: 0.53rem;
  }

  .catalog-list {
    padding-top: 0.64rem;
  }

  .catalog-list-item {
    .catalog-classify {
      font-size: 0.37rem;
      color: #3c3d42;
      padding-left: 0.3rem;
      position: relative;
      margin-bottom: 0.43rem;

      &::after {
        position: absolute;
        content: ' ';
        display: block;
        width: 0.08rem;
        height: 0.32rem;
        background: linear-gradient(
          360deg,
          rgba(19, 191, 128, 0.5) 0%,
          rgba(19, 191, 128, 0.8) 100%
        );
        border-radius: 0.01rem 0.01rem 0.01rem 0.01rem;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.bg-white {
  background: #fff;
  padding-left: 0.53rem;
  padding-right: 0.53rem;
}

.series {
  &-header {
    padding-top: 0.32rem;

    .name {
      position: relative;
      font-size: 0.37rem;
      line-height: 1;
      color: #8d8e92;
      padding-left: 0.3rem;
      margin-bottom: 0.2rem;

      .icon {
        @include position_centerY;
        left: 0;
        top: 50%;
        width: 0.08rem;
        height: 0.32rem;
        background: linear-gradient(
          360deg,
          rgba(var(--main-rgba), 0.5) 0%,
          rgba(var(--main-rgba), 0.8) 100%
        );
        //background-color: var(--main-color);
        border-radius: 2px;
      }
    }
  }

  &-card {
    padding: 0.32rem;
    margin-bottom: 0.32rem;
    box-shadow: 0px 1px 6px rgba(145, 148, 153, 0.1);
    border-radius: 8px;
    border: 1px solid transparent;
    background: #fff;
    width: 100%;
    margin-right: 0;

    &[aria-checked='true'] {
      // background: rgba(var(--main-rgba), 0.05);
      border: 1px solid var(--main-color);

      &.van-checkbox--disabled {
        background: #fff;
        border: 1px solid transparent;
      }

      .button {
        background: rgba(var(--main-rgba), 0.05);
        border: 1px solid rgba(var(--main-rgba), 0.6);
      }
    }

    /deep/ {
      .van-checkbox__label {
        width: 100%;
        margin-left: 0.32rem;
      }

      .van-checkbox__icon {
        width: 0.5rem;
        height: 0.5rem;
        box-sizing: border-box;
      }

      .img-icon {
        width: 0.5rem;

        &.disabled {
          opacity: 0.5;
        }
      }
    }

    &.disabled {
      .name,
      .price {
        opacity: 0.5;
      }
    }

    .name {
      font-size: 0.4rem;
      line-height: 0.53rem;
      color: #22242e;
      margin-bottom: 0.2rem;
    }

    .price {
      color: #ff6a4d;

      .symbol {
        font-size: 0.27rem;
      }

      .number {
        font-size: 0.37rem;
      }

      .vip-number {
        display: inline-block;
        margin-left: 0.2rem;
        font-size: 0.29rem;
        font-weight: 400;
        color: #e5b66e;
        transform: translateY(-0.02rem);
      }

      .old-number {
        font-size: 0.29rem;
        line-height: 0.59rem;
        color: #919499;
        text-decoration: line-through;
      }
    }

    .button {
      @include flex_center;
      padding: 0 0 0 0.1rem;
      width: 1.33rem;
      height: 0.53rem;
      background: #ffffff;
      border: 1px solid rgba(194, 197, 204, 0.2);
      font-size: 0.29rem;
      color: #3c3d42;
      box-sizing: border-box;

      .icon {
        width: 0.16rem;
        vertical-align: middle;
        margin-left: 0.1rem;
      }
    }
  }
}

.course-item {
  .title {
    font-size: 0.37rem;
    color: #22242e;
    line-height: 0.56rem;
    overflow: hidden; //超出文本隐藏
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //自定义行数
  }

  .content {
    display: flex;
    justify-content: space-between;
    margin-top: 0.21rem;

    &-left {
      display: flex;
      align-items: center;

      p {
        font-size: 0.37rem;
        color: #ff6a4d;
      }
    }

    &-right {
      font-size: 0.29rem;
      color: var(--main-color);
      display: flex;
      align-items: center;
    }

    .money {
      font-size: 0.37rem;
      color: #ff6a4d;

      span {
        font-size: 0.27rem;
        color: #ff6a4d;
      }
    }

    .specs {
      background: #f7f8fa;
      border-radius: 0.32rem;
      padding: 0.08rem 0.32rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 0.32rem;

      span {
        font-size: 0.29rem;
        color: #666;
      }

      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}

.specs-action {
  padding-bottom: 0.6rem;

  .van-action-sheet__header {
    padding: 0.59rem 0;
    font-size: 0.48rem;
    line-height: 1;
    color: #18191a;
    text-align: left;
    font-weight: bold;
  }
}

.van-checkbox-group--horizontal {
  width: 100%;
}

.green-box {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.green-h {
  background: linear-gradient(180deg, #09af72 0%, #2bcc92 100%);
  height: 3.5rem;
  padding: 0.53rem 0.53rem 0.56rem 0.53rem;
  box-sizing: border-box;

  .title {
    font-size: 0.48rem;
    color: #fff;
    margin-bottom: 0.2rem;
  }

  span {
    font-size: 0.4rem;
    color: rgba(255, 255, 255, 0.8);
  }
}

.green-content {
  background: #f7f8fa;
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  margin-top: -0.5rem;
  padding: 0.43rem 0.32rem;
  border-radius: 0.32rem 0.32rem 0 0;
  overflow: auto;
}

.course-item-t {
  background: #fff;
  border-radius: 0.21rem;
  padding: 0.32rem;
  margin-bottom: 0.32rem;

  .course-card-title {
    font-size: 0.4rem;
    line-height: 1.5;
    color: #333;

    .label-box {
      border-radius: 20px;
      font-size: 0.29rem;
      position: relative;
      display: inline-block;
      padding: 0.1rem 0.27rem 0.1rem 0.6rem;
      font-weight: normal;
      line-height: 1;

      img {
        width: 0.53rem;
        height: 0.53rem;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      span {
        font-size: 0.48rem;
      }
    }
  }

  .course-summary {
    font-size: 0.32rem;
    color: #919499;
    margin-top: 0.2rem;
  }

  .course-item-bt {
    margin-top: 0.53rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .teacher-list {
      display: flex;
      align-items: center;
    }

    .teacher-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 0.27rem;

      img {
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 50%;
        margin-bottom: 0.05rem;
      }

      font-size: 0.27rem;
      color: #919499;
    }

    .right-con {
      .money {
        text-align: right;

        span {
          font-size: 0.32rem;
          color: var(--main-color);
        }

        font-size: 0.43rem;
        color: var(--main-color);
      }

      .free {
        font-size: 0.37rem;
        color: var(--main-color);
        text-align: right;
      }

      .people {
        font-size: 0.27rem;
        color: #c2c5cc;
        margin-top: 0.11rem;
      }
    }
  }
}

.paddingShow {
  padding-bottom: 1.7rem;
}

.catalog-margin .check-item:last-child .series-card {
  margin-bottom: 0.64rem;
}

/deep/ .van-checkbox__icon--disabled .van-icon {
  width: 1.25em;
  height: 1.25em;
  background: url(../../assets/images/collection/icon-disable.png);
  display: inline-block;
  content: '';
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-color: rgb(235, 236, 240);
}

/deep/ .van-checkbox__icon .van-icon {
  border-color: #ecedf1;
}
</style>
